// project import
import Routes from 'routes';
import ThemeCustomization from 'themes';
import Locales from 'components/Locales';
// import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';

// auth provider
import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';
import { UpgradeDrawerProvider } from 'contexts/UpgradeDrawerContext';
import AnalyticsProvider from 'lib/analytics/AnalyticsProvider';
// import AppOnlineStatus from './app-online-status/AppOnlineStatus';

import { config } from './env';
import ReactGA from 'react-ga4';
import AppVersionChecker from './components/app-version-checker/AppVersionChecker';
import OverDueWarning from './components/overdue-warning/OverDueWarning';
import { SubscriptionFreezeProvider, useSubscriptionFreeze } from './features/subscription-freeze/SubscriptionFreezeContext';
import CancellationDialogHost from 'features/cancellation/components/CancellationDialog';
import { useEffect } from 'react';
ReactGA.initialize(config.google_analytics_tracker);

// Clear chunk error reload flag on successful app load
const CHUNK_RELOAD_KEY = 'chunk_error_reload_attempted';

function SubscriptionAwareOverDueWarning() {
  const { freeze, loading } = useSubscriptionFreeze();
  return loading || freeze ? null : <OverDueWarning />;
}

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => {
  // Clear the chunk reload flag when app mounts successfully
  useEffect(() => {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  }, []);

  return (
    <ThemeCustomization>
      {/* <RTLLayout> */}
      <Locales>
        <ScrollTop>
          <AuthProvider>
            <AnalyticsProvider>
              <SubscriptionFreezeProvider>
                <UpgradeDrawerProvider>
                  <>
                    <Routes />
                    <Snackbar />
                    <AppVersionChecker />
                    <SubscriptionAwareOverDueWarning />
                    <CancellationDialogHost />
                    {/*<AppOnlineStatus />*/}
                  </>
                </UpgradeDrawerProvider>
              </SubscriptionFreezeProvider>
            </AnalyticsProvider>
          </AuthProvider>
        </ScrollTop>
      </Locales>
      {/* </RTLLayout> */}
    </ThemeCustomization>
  );
};

export default App;
